import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, GenesisUnitOfWork, ReportService, SessionInformationService } from 'app/core/core.module';
import { InvoiceService } from 'app/core/data/invoice-service';
import { HistoryService } from 'app/core/history.service';
import { Dealer } from 'app/core/model/dealer';
import { PackingSlip } from 'app/core/model/packing-slip';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { alert, confirm } from 'devextreme/ui/dialog';
import { Invoice } from 'app/core/model/entity-model';

@Component({
    selector: 'app-invoice-history',
    templateUrl: './invoice-history.component.html',
    styleUrls: ['./invoice-history.component.scss'],
    standalone: false
})
export class InvoiceHistoryComponent implements OnInit {
    filter: any;
    invoices: any[];
    dealers: Dealer[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private reportService: ReportService,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private invoiceService: InvoiceService,
        private historyService: HistoryService,
    ) {}

    async ngOnInit() {
        this.dealers = await this.uow.getDealers();
        const filter = this.sessionInfo.getItem('invoice-history-filter');
        if (filter) {
            this.filter = filter;
            await this.search();
        } else this.filter = {};
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.invoices = await this.historyService.getInvoiceHistory(this.filter);
        this.sessionInfo.setItem('invoice-history-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.filter = {};
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onRowDoubleClick(e) {
        this.open(e.data);
    }

    open(invoice: any) {
        if (!invoice) return;
        this.router.navigate([`/invoices/${invoice.id}`]);
    }

    async openInvoiceOrder(invoiceNumber: number) {
        const order = (await this.uow.getOrdersByInvoiceNumbers([invoiceNumber]))[0];
        if (!order) return;
        this.router.navigate([`/sales-orders/${order.id}`]);
    }

    async printPackingSlip(packSlipNumber: any) {
        const reportGuid = ((await this.uow.getPackSlipByNumber(packSlipNumber)) as PackingSlip).reportGuid;
        this.reportService.openPackingSlip([reportGuid]);
    }

    async printInvoice(cell: any) {
        if (cell.column.dataField === 'invoiceNumber') {
            const reportGuid = ((await this.uow.getInvoiceByInvoiceNumber(cell.value)) as Invoice).reportGuid;
            this.reportService.openInvoiceReport([reportGuid]);
        }
    }

    async applyPayment() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        await this.invoiceService.receivePayment(selectedRows[0]);
    }

    async queueForQBBridge() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length === 0) return;

        const result = await confirm(
            `Are you sure you want to ReQueue the selected ${selectedRows.length === 1 ? 'invoice' : 'invoices'} for the Bridge?`,
            `${this.appInfo.settings.company}`
        );
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const ids = selectedRows.map((x) => {
            return x.id;
        });
        const invoices = (await this.uow.invoices.byIds(ids)) as Invoice[];
        invoices.forEach((row) => {
            row.quickBooksLastExport = null;
        });
        await this.uow.commit();
        await this.search();
        this.appInfo.pleaseWaitHide();
    }
}
